import { ChainId } from 'sdk-core/chains'

// CoinGecko API currency IDs for native tokens per chain
// See: https://api.coingecko.com/api/v3/coins/list
export const COINGECKO_NATIVE_IDS: { [chainId: number]: string } = {
  [ChainId.MAINNET]: 'ethereum',
  [ChainId.OPTIMISM]: 'ethereum',
  [ChainId.ARBITRUM_ONE]: 'ethereum',
  [ChainId.BASE]: 'ethereum',
  [ChainId.DBK]: 'ethereum',
  [ChainId.KATANA]: 'ethereum',
  [ChainId.MEGAETH]: 'ethereum',
  [ChainId.POLYGON]: 'matic-network',
  [ChainId.BNB]: 'binancecoin',
  [ChainId.AVALANCHE]: 'avalanche-2',
  [ChainId.CELO]: 'celo',
  [ChainId.BERACHAIN]: 'berachain-bera',
  [ChainId.HYPERLIQUID]: 'hyperliquid',
  [ChainId.SONIC]: 'sonic-3',
  [ChainId.MITOSIS]: 'mitosis',
  [ChainId.MONAD]: 'monad',
  [ChainId.SOMNIA]: 'somnia',
  [ChainId.ZEROG]: 'zero-gravity',
  [ChainId.PLASMA]: 'plasma',
}

// Chains where native currency is a stablecoin (worth $1, no API call needed)
export const STABLECOIN_NATIVE_CHAINS: Set<number> = new Set([
  ChainId.STABLE,  // gUSDT
])

// How long to cache CoinGecko prices (3 minutes)
export const PRICE_CACHE_MS = 3 * 60 * 1000

// CoinGecko API endpoint
export const COINGECKO_API_URL = 'https://api.coingecko.com/api/v3/simple/price'

// Fetch native currency price from CoinGecko
export async function fetchNativeCurrencyPrice(currencyId: string): Promise<number | null> {
  try {
    const response = await fetch(`${COINGECKO_API_URL}?ids=${currencyId}&vs_currencies=usd`)
    if (!response.ok) return null
    const data = await response.json()
    return data[currencyId]?.usd ?? null
  } catch {
    return null
  }
}
